export default {"src":"/_next/static/media/minus.e01a0c70.svg","height":25,"width":25};